import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles =
    'inline-flex items-center justify-center font-semibold rounded-lg transition-all focus-brand disabled:opacity-50 disabled:cursor-not-allowed';

  // Button styles per Brand Guidelines
  const variantStyles = {
    // Primary Button: Forest Green background (#3A7D44)
    primary:
      'bg-primary text-white hover:bg-primary-dark active:bg-primary-dark shadow-md hover:shadow-brand',
    // Secondary Button: Transparent with Forest Green border
    secondary:
      'bg-transparent border-2 border-primary text-primary hover:bg-primary-pale active:bg-primary-pale',
    // Outline Button: Alternative secondary style
    outline:
      'bg-transparent border-2 border-primary text-primary hover:bg-primary-pale active:bg-primary-pale',
    // Accent Button: Coral Orange for CTAs (#FF8A3D)
    accent:
      'bg-orange text-white hover:bg-orange-dark active:bg-orange-dark shadow-md hover:shadow-lg',
  };

  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  const widthStyles = fullWidth ? 'w-full' : '';

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
